// import { UnauthenticatedTemplate} from "@azure/msal-react"
// import '../login.css';

// function Login({handleLoginRedirect}) {

//   return (
//     <div className="login-container">
//       <UnauthenticatedTemplate>
//         {/* Desktop Layout */}
//         <div className="desktop-layout bg-[#1e1e1e]">
//           <div className="left-section">
//             <div className="logo-section">
//               <img src="/NTU-LKCMedicine_Rev-Colour.png" alt="Logo" className="logo-image" />
//             </div>
            
//             <div className="content-section">
//               <h1 className="chatbot-title">Experimental Sandbox</h1>
//               <p className="description-text">
//                 Sign in to access the Experimental Sandbox — explore multiple AI models, and tools like image generation, Context/RAG file uploads, audio transcription, and PDF-to-PPTX summarisation.
//               </p>
//               <button className="login-button" onClick={handleLoginRedirect}>
//                 LOGIN
//               </button>
//             </div>
//           </div>
          
//           <div className="right-section">
//             <div className="visuals-container">
//               <img src="/main.png" alt="Main Visual" className="main-visual-image" />
//               <div className="floating-blob-1"></div>
//               <div className="floating-blob-2"></div>
//               <div className="floating-blob-3"></div>
//             </div>
//           </div>
//         </div>

//         {/* Mobile Layout */}
//         <div className="mobile-layout bg-[#1e1e1e]">
//           <div className="mobile-header">
//             <div className="mobile-visual">
//               <img src="/main.png" alt="Mobile Visual" className="mobile-visual-image" />
//               <img src="/NTU-LKCMedicine_Rev-Colour.png" alt="Mobile Logo" className="mobile-logo-image" />
//             </div>
//           </div>
          
//           <div className="mobile-content">
//             <h1 className="mobile-title">Experimental Sandbox</h1>
//             <p className="mobile-description-text">
//               Sign in to access the Experimental Sandbox — explore multiple AI models, and tools like image generation, Context/RAG file uploads, audio transcription, and PDF-to-PPTX summarisation.
//             </p>
//             <button className="mobile-login-button" onClick={handleLoginRedirect}>
//               LOGIN
//             </button>
//           </div>
//         </div>
//       </UnauthenticatedTemplate>
//     </div>
//   );
// }

// export default Login;


import { UnauthenticatedTemplate } from "@azure/msal-react";
import '../login.css';

function Login({ handleLoginRedirect }) {
  return (
    <div className="min-h-screen w-full bg-[#1e1e1e] text-white">
      <UnauthenticatedTemplate>
        {/* Logo (top-left, all screens) */}
        <div className="logo-section">
          <img src="/NTU-LKCMedicine_Rev-Colour.png" alt="Logo" className="logo-image" />
        </div>

        {/* Main layout */}
        <div className="relative mx-auto flex min-h-screen max-w-6xl flex-col items-center justify-center gap-10 px-6 py-16 md:flex-row md:gap-16">
          {/* Left: content */}
          <div className="w-full max-w-xl text-center md:text-left">
            <h1 className="text-4xl font-bold leading-tight tracking-tight md:text-5xl">
              Experimental Sandbox
            </h1>

            <p className="mt-6 text-base leading-relaxed text-neutral-300 md:text-lg md:leading-[1.9]">
              Sign in to access the Experimental Sandbox — explore multiple AI models, and tools
              like image generation, Context/RAG file uploads, audio transcription, and
              PDF-to-PPTX summarisation.
            </p>

            <div className="mt-8 flex justify-center md:justify-start">
              <button
                onClick={handleLoginRedirect}
                className="rounded-xl border-2 border-[#646cff] bg-gradient-to-br from-[#646cff] to-[#535bf2] px-8 py-3 text-sm font-semibold tracking-wider text-white shadow-lg shadow-[#646cff]/20 transition hover:-translate-y-0.5 hover:from-[#535bf2] hover:to-[#4338ca] hover:shadow-[#646cff]/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#646cff]/60"
              >
                LOGIN
              </button>
            </div>
          </div>

          {/* Right: visual */}
          <div className="relative w-full max-w-sm">
            <div className="relative aspect-square w-full">
              {/* Decorative blobs (more organic) */}
              <div className="pointer-events-none absolute -right-14 -top-16 h-52 w-52 blob blob-a" />
              <div className="pointer-events-none absolute -left-16 -bottom-14 h-48 w-48 blob blob-b" />
              <div className="pointer-events-none absolute -left-10 top-[22%] h-40 w-40 blob blob-c" />

              {/* Extra blobs */}
              <div className="pointer-events-none absolute right-6 top-[35%] h-36 w-36 blob blob-d" />
              <div className="pointer-events-none absolute left-[30%] -top-12 h-32 w-32 blob blob-e" />
              <div className="pointer-events-none absolute right-[25%] -bottom-16 h-44 w-44 blob blob-f" />
              <div className="pointer-events-none absolute left-[55%] top-[8%] h-28 w-28 blob blob-g" />


              {/* Main image (moving) */}
              <div className="relative z-10 h-full w-full animate-floatMain will-change-transform">
                <img
                  src="/main.png"
                  alt="Main Visual"
                  className="h-full w-full object-cover shadow-2xl animate-morphMain will-change-[border-radius]"
                  draggable={false}
                />
              </div>


              {/* soft border */}
              <div
                className="pointer-events-none absolute inset-2 z-0 rounded-[42%_58%_54%_46%/42%_44%_56%_58%] ring-1 ring-white/10"
                aria-hidden="true"
              />
            </div>
          </div>
        </div>
      </UnauthenticatedTemplate>
    </div>
  );
}

export default Login;
